export default __webpack_public_path__ + "static/media/cargoBike-nav-completed.6eb205f1.svg";